(() => {
  class VeloraProductRailHero {
    constructor(root) {
      this.root = root;
      this.cards = [...root.querySelectorAll('[data-vprh-card]')];
      this.numbers = [...root.querySelectorAll('[data-vprh-number]')];
      this.addButtons = [...root.querySelectorAll('[data-vprh-add-to-cart]')];

      this.activeIndex = 0;

      this.bind();
      this.setActive(0, false);
    }

    bind() {
      this.numbers.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.setActive(index, true);
        });
      });

      this.cards.forEach((card, index) => {
        card.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            this.setActive(index, false);
          }
        });

        card.addEventListener('focusin', (event) => {
          if (!event.target.closest('[data-vprh-add-to-cart]')) {
            this.setActive(index, false);
          }
        });
      });

      this.addButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.addToCart(button);
        });
      });
    }

    async addToCart(button) {
      if (button.disabled || button.classList.contains('is-loading')) return;

      const variantId = Number(button.dataset.variantId);

      if (!variantId) return;

      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const root =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        const result = await response.json();

        button.classList.add('is-success');

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              source: 'velora-product-rail-hero',
              result
            }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        setTimeout(() => {
          button.classList.remove('is-success');
        }, 1500);

      } catch (error) {
        console.error('Velora quick add:', error);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    }

    setActive(index, scroll) {
      if (!this.cards.length) return;

      index = Math.max(
        0,
        Math.min(index, this.cards.length - 1)
      );

      this.activeIndex = index;

      this.cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });

      this.numbers.forEach((button, i) => {
        const active = i === index;

        button.classList.toggle('is-active', active);
        button.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );
      });

      if (scroll && this.cards[index]) {
        this.cards[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-vprh]').forEach((root) => {
      if (root.dataset.vprhReady === 'true') return;

      root.dataset.vprhReady = 'true';

      new VeloraProductRailHero(root);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
